<template>
  <div>
    <v-app :dark="false" :style="{ backgroundColor: getThemeColor }">
      <v-container class="mt-4">
        <vAlertHeader
          title="Generate Documents With Docs-Ai "
          color="#263238"
          class="mb-n4"
        ></vAlertHeader>
        <!-- <v-alert v-if="remainingDocsMessage" type="info" dense text>
          {{ remainingDocsMessage }}
        </v-alert> -->

        <Loader></Loader>

        <!-- V-Stepper -->
        <v-stepper v-model="currentStep" vertical>
          <v-stepper-step
            :complete="currentStep > 1"
            step="1"
            :color="currentStep > 1 ? 'success' : 'primary'"
          >
            <h6>Select Document You Want To Generate</h6>
            <small>Simply Click To Select</small>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-radio-group v-model="selectedDocType">
              <v-card class="mb-8">
                <!-- Virtual Scroller For Mobile -->
                <div v-if="isMobile">
                  <v-card flat class="mx-auto">
                    <v-virtual-scroll
                      :bench="0"
                      :items="documentTypes"
                      height="400"
                      item-height="84"
                    >
                      <template v-slot:default="{ item }">
                        <v-list-item :key="item.key">
                          <v-list-item-action>
                            <v-btn fab x-small depressed color="red" dark>
                              <v-icon>mdi-file-pdf</v-icon>
                            </v-btn>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-card-subtitle>
                              <strong>{{ item.label }}</strong>
                            </v-card-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-radio
                              :value="item.key"
                              @click="getSelectedDocTemplateUrl"
                            ></v-radio>
                          </v-list-item-action>
                        </v-list-item>

                        <v-divider></v-divider>
                      </template>
                    </v-virtual-scroll>
                  </v-card>
                </div>
                <!-- End of Virtual Scroller For Mobile -->

                <!-- Cards For Desktop -->
                <div v-else>
                  <v-row>
                    <v-col
                      :cols="3"
                      v-for="(item, ind) in documentTypes"
                      :key="ind"
                    >
                      <v-card>
                        <v-card-text>
                          <v-row align="center" class="mx-0">
                            <!-- <v-btn fab x-small depressed color="red" dark> -->
                            <v-icon color="red" dark>mdi-file-pdf</v-icon>
                            <!-- </v-btn> -->
                            <v-radio
                              :value="item.key"
                              @click="getSelectedDocTemplateUrl"
                            >
                              <template v-slot:label>
                                <div>
                                  <strong class="brown--text">{{
                                    item.label
                                  }}</strong>
                                </div>
                              </template>
                            </v-radio>
                          </v-row>
                        </v-card-text>
                      </v-card></v-col
                    >
                  </v-row>
                </div>

                <!-- End of Cards For Desktop -->
              </v-card>
            </v-radio-group>
            <v-btn
              color="success"
              @click="
                selectedDocType
                  ? (currentStep = 2)
                  : $toast.error('No Document Selected!')
              "
            >
              Continue
            </v-btn>
          </v-stepper-content>

          <v-stepper-step
            :complete="currentStep > 2"
            step="2"
            :color="currentStep > 2 ? 'success' : 'primary'"
          >
            <h6>Provide Extra Info If Necessary [Optional]</h6>
            <small>Help the Ai to serve you better.</small>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-card class="mb-8">
              <!-- Dynamic Form Inputs -->
              <v-form
                ref="form"
                v-model="formValid"
                lazy-validation
                class="mt-4"
              >
                <!-- Your existing dynamic fields for document type -->
                <v-row>
                  <v-col
                    :cols="isMobile ? 12 : 4"
                    v-for="(field, key) in getDocFields[selectedDocType] || {}"
                    :key="key"
                  >
                    <v-text-field
                      v-model="docData[key]"
                      :label="field.label"
                      :rules="[(v) => !!v || 'Required']"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-textarea
                    class="mx-4"
                    v-model="extraSpecificRequirement"
                    label="Any Extra Details"
                    outlined
                    :rows="2"
                  ></v-textarea>
                </v-row>

                <!-- Brand Information -->

                <v-expansion-panels>
                  <v-expansion-panel v-for="(item, i) in 1" :key="i">
                    <v-expansion-panel-header
                      color="wheat"
                      style="background-color: #263238; color: wheat"
                    >
                      Brand Your Document [Optional]
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row class="mt-4">
                        <v-col :cols="isMobile ? 12 : 4"
                          ><v-text-field
                            v-model="brand.name"
                            label="Brand Name"
                            :rules="[(v) => !!v || 'Required']"
                            outlined
                            dense
                          ></v-text-field
                        ></v-col>
                        <v-col :cols="isMobile ? 12 : 4"
                          ><v-text-field
                            v-model="brand.phone"
                            label="Brand Contact Number"
                            outlined
                            dense
                          ></v-text-field
                        ></v-col>
                        <v-col :cols="isMobile ? 12 : 4">
                          <v-file-input
                            v-model="brand.logoFile"
                            label="Upload Logo Image"
                            accept="image/*"
                            outlined
                            dense
                            @change="handleLogoUpload"
                          ></v-file-input
                        ></v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-textarea
                            v-model="brand.address"
                            label="Business Address"
                            :rows="1"
                            outlined
                            dense
                          ></v-textarea
                        ></v-col>
                      </v-row>

                      <!-- <v-text-field
                        v-model="brand.logoUrl"
                        label="Logo URL"
                        outlined
                        dense
                        hint="Or upload an image below"
                        persistent-hint
                      ></v-text-field> -->
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-form></v-card
            >
            <v-btn
              color="success"
              @click="
                formValid
                  ? (currentStep = 3)
                  : $toast.info('Its Helpful To Provide Extra Info')
              "
            >
              Continue
            </v-btn>
            <v-btn text @click="currentStep = 1"> Back </v-btn>
          </v-stepper-content>

          <v-stepper-step
            :complete="currentStep > 3"
            step="3"
            :color="currentStep > 3 ? 'success' : 'primary'"
          >
            <h6>Generate Document</h6>
            <small>Click on button to Generate PDF</small>
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-card class="mb-8">
              <v-btn color="success" @click="generateDocument">
                Generate Now
              </v-btn>
              <v-btn text @click="currentStep = 2"> Back </v-btn>
              <iframe
                :src="pdfBlobUrl"
                width="100%"
                height="1200px"
                frameborder="0"
              ></iframe>
              <v-btn
                color="teal"
                class="mt-3 white--text"
                @click="downloadPDF"
                :disabled="!paymentDone"
                >Download PDF</v-btn
              ></v-card
            >
          </v-stepper-content>
        </v-stepper>

        <!-- End of V-Stepper -->
        <v-card
          flat
          class="pa-4"
          :style="{ backgroundColor: 'white', borderRadius: '12px' }"
        >
          <!-- Document Type Selection -->
          <!-- <v-select
            v-model="selectedDocType"
            :items="documentTypes"
            label="Select Document Type"
            item-text="label"
            item-value="key"
            outlined
            class="mt-4"
            @change="getSelectedDocTemplateUrl"
          ></v-select> -->

          <!-- Limits Info -->

          <!-- Payment + Generate Button -->
          <!-- <v-row class="mt-5" align="center">
            <v-col cols="12" md="6">
              <v-btn
                color="teal"
                large
                class="white--text"
                :loading="loading"
                :disabled="!formValid"
                @click="generateDocument"
              >
                Generate Document
              </v-btn>
            </v-col> -->
          <!-- <v-col cols="12" md="6">
              <v-btn-toggle v-model="selectedTier" mandatory>
                <v-btn value="single">R99 / Doc</v-btn>
                <v-btn value="monthly">R199 / Month</v-btn>
                <v-btn value="yearly">R1999 / Year</v-btn>
              </v-btn-toggle>
            </v-col> -->
          <!-- </v-row> -->

          <!-- Payment Options -->
          <!-- <v-row class="mt-4">
            <v-col cols="6">
              <v-btn color="blue" block @click="payWithPayPal"
                >Pay with PayPal</v-btn
              >
            </v-col>
            <v-col cols="6">
              <v-btn color="green" block @click="payWithPayFast"
                >Pay with PayFast</v-btn
              >
            </v-col>
          </v-row> -->

          <!-- PDF Preview -->
          <!-- <v-card flat class="mt-6 pa-4" v-if="pdfContent">
            <h3 class="subtitle-1 mb-2">Preview</h3>
            <iframe
              :src="pdfBlobUrl"
              width="100%"
              height="1200px"
              frameborder="0"
            ></iframe>
            <v-btn color="teal" class="mt-3 white--text" @click="downloadPDF"
              >Download PDF</v-btn
            >
          </v-card> -->

          <!-- watermark -->
          <!-- <v-card class="pa-4" elevation="2">
          <div style="position: relative">
            
            <div
              v-if="isGuestOrLimited && !paymentDone"
              style="
                position: absolute;
                top: 20%;
                left: 10%;
                transform: rotate(-20deg);
                font-size: 3em;
                color: rgba(0, 0, 0, 0.1);
                pointer-events: none;
                z-index: 1;
              "
            >
              WATERMARK - PREVIEW ONLY
            </div>

           
          </div>
        </v-card> -->
        </v-card>
      </v-container>
      <v-dialog
        v-model="showPaymentModal"
        persistent
        max-width="400px"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="headline teal white--text">
            Unlock Full Document
          </v-card-title>
          <v-card-text>
            <p>You're viewing a preview with watermark.</p>
            <p>Purchase full access for R99.</p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="success"
              :loading="loadingPayfast"
              @click="payWithPayFast"
            >
              Pay with PayFast
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :loading="loadingPaypal"
              @click="payWithPayPal"
            >
              Pay with PayPal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import Loader from "@/components/Loader";
import vAlertHeader from "@/components/Legos/vAlertHeader";

// export default {
//   components: { vAlertHeader, Loader },
//   computed: {
//     isMobile() {
//       return this.$store.getters.isMobile;
//     },
//     maxDocsThisMonth() {
//       const plan = this.getCurrentUser?.plan;
//       if (plan === "monthly") return 100;
//       if (plan === "yearly") return 100; // monthly soft cap within yearly
//       return 0;
//     },
//     maxDocsThisYear() {
//       return this.getCurrentUser && this.getCurrentUser.plan === "yearly"
//         ? 1200
//         : 0;
//     },
//     isLimitExceeded() {
//       const user = this.getCurrentUser;
//       if (!user || user.alevel < 7) return false;

//       if (user.plan === "monthly") {
//         return user.generatedDocsThisMonth >= this.maxDocsThisMonth;
//       }

//       if (user.plan === "yearly") {
//         return user.generatedDocsThisYear >= this.maxDocsThisYear;
//       }

//       return false;
//     },
//     remainingDocsMessage() {
//       const user = this.getCurrentUser;
//       if (!user || user.alevel < 7) return "";
//       if (user.plan === "monthly") {
//         return `You have ${
//           this.maxDocsThisMonth - user.generatedDocsThisMonth
//         } of ${this.maxDocsThisMonth} documents left this month.`;
//       }
//       if (user.plan === "yearly") {
//         return `You have ${
//           this.maxDocsThisYear - user.generatedDocsThisYear
//         } of ${this.maxDocsThisYear} documents left this year.`;
//       }
//       return "";
//     },
//     getCurrentUser() {
//       // Simulate a logged-in user or guest
//       return {
//         name: "John Doe",
//         email: "john@example.com",
//         alevel: 1, // >=7 means paid access
//         plan: "monthly", // or 'yearly' or null
//         generatedDocsThisMonth: 12,
//         generatedDocsThisYear: 55,
//       };
//     },
//     getThemeColor() {
//       return "#008080";
//     },
//     isGuestOrLimited() {
//       return !this.getCurrentUser || this.getCurrentUser.alevel < 7;
//     },
//     // maskedContent() {
//     //   if (!this.pdfContent || typeof this.pdfContent !== "object") return "";

//     //   if (this.isGuestOrLimited && !this.paymentDone) {
//     //     // Shallow clone the pdf definition and truncate the content
//     //     const masked = {
//     //       ...this.pdfContent,
//     //       content: this.pdfContent.content.slice(
//     //         0,
//     //         Math.floor(this.pdfContent.content.length / 2)
//     //       ),
//     //     };

//     //     // Add upgrade prompt at the end
//     //     masked.content.push({
//     //       text: "\n\n[Upgrade to view full document]",
//     //       style: "body",
//     //       italics: true,
//     //       color: "gray",
//     //     });

//     //     return masked;
//     //   } else {
//     //     return this.pdfContent;
//     //   }
//     // },
//     // maskedContent() {
//     //   if (!this.pdfContent) return "";
//     //   return this.isGuestOrLimited && !this.paymentDone
//     //     ? this.pdfContent.slice(0, Math.floor(this.pdfContent.length / 2)) +
//     //         "\n\n[Upgrade to view full document]"
//     //     : this.pdfContent;
//     // },
//     documentTypes() {
//       return [
//         {
//           key: "affidavit_for_lost_id",
//           label: "Affidavit for Lost ID",
//           templateUrl: null,
//           prompt: `
//         Create a sworn affidavit for {{name}} (ID: {{id}}) declaring the loss of ID on {{lossDate}}. Circumstances: {{details}}.
//           `,
//         },
//         {
//           key: "business_plan",
//           label: "Business Plan",
//           templateUrl: null,
//           prompt: `
//         Create a business plan for {{businessName}} owned by {{ownerName}} in the {{sector}} sector. Goals: {{goals}}. Products: {{products}}. Market: {{market}}. Finances: {{financeSummary}}.
//           `,
//         },
//         {
//           key: "travel_consent_for_minor",
//           label: "Travel Consent for Minor",
//           templateUrl: null,
//           prompt: `
//         Create a travel consent letter by {{parent}} for their minor child {{child}} to travel to {{destination}} from {{dates}}, accompanied by {{accompanying}}.
//           `,
//         },
//         {
//           key: "letter_of_good_standing",
//           label: "Letter of Good Standing",
//           templateUrl: null,
//           prompt: `
//         Create a formal request for a letter of good standing by {{name}} (ID/Reg: {{idNumber}}) representing {{company}}. Reason: {{reason}}.
//           `,
//         },
//         {
//           key: "freelance_contract",
//           label: "Freelance Service Agreement",
//           templateUrl: null,
//           prompt: `
//         Draft a freelance service agreement between {{freelancer}} and {{client}}. Services: {{services}}. Fee: R{{fee}}. Deadline: {{deadline}}.
//           `,
//         },
//         {
//           key: "vehicle_sale_agreement",
//           label: "Vehicle Sale Agreement",
//           templateUrl: null,
//           prompt: `
//         Generate a vehicle sale agreement between {{sellerName}} and {{buyerName}} for {{vehicleDetails}} (Reg: {{registrationNumber}}) at R{{salePrice}}, dated {{saleDate}}. Include warranties and terms.
//           `,
//         },
//         {
//           key: "invoice",
//           label: "Quotation + Invoice Template",
//           templateUrl:
//             "https://www.invoiceberry.com/img/homepage/free_invoice_templates/new/sub_pages/south-africa/screenshot_invoiceberry_invoice_template_5.png",
//         },
//         {
//           key: "acknowledgement_of_debt",
//           label: "Acknowledgement of Debt",
//           templateUrl: null,
//           prompt: `
//         Generate a formal acknowledgement of debt by {{debtor}} to {{creditor}} for {{amount}}. Payment terms: {{terms}}. Agreement dated: {{date}}.
//           `,
//         },
//         {
//           key: "late_payment",
//           label: "Late Payment Reminder Letter",
//           templateUrl: null,
//           prompt: null,
//         },
//         {
//           key: "debt_collection",
//           label: "Debt Collection Letter",
//           templateUrl: null,
//           prompt: null,
//         },
//         {
//           key: "stokvel_membership_agreement",
//           label: "Stokvel Membership Agreement",
//           templateUrl: null,
//           prompt: `
//         Write a South African stokvel membership agreement for {{member}} joining {{stokvel}} with contributions of R{{amount}} made {{frequency}}. Agreement date: {{date}}.
//           `,
//         },
//         {
//           key: "nda",
//           label: "Non-Disclosure Agreement",
//           templateUrl: null,
//           prompt: `
//         Generate a legally binding NDA between {{discloser}} and {{receiver}}. Purpose: {{purpose}}. Effective from {{effectiveDate}} for {{duration}} months.
//           `,
//         },
//         { key: "contract", label: "General Contract", templateUrl: null },
//         {
//           key: "partnership",
//           label: "Partnership Agreement",
//           templateUrl: null,
//           prompt: null,
//         },
//         {
//           key: "lease",
//           label: "Lease Agreement (Residential)",
//           templateUrl: null,
//           prompt: null,
//         },
//         {
//           key: "lease_cancellation_letter",
//           label: "Lease Cancellation Letter",
//           templateUrl: null,
//           prompt: `
//         Write a lease cancellation letter from {{tenantName}} to {{landlordName}} regarding {{address}}, effective {{cancelDate}}. Reason: {{reason}}.
//           `,
//         },
//         { key: "resignation", label: "Resignation Letter", templateUrl: null },
//         { key: "employment", label: "Employment Contract", templateUrl: null },
//         {
//           key: "employment_reference_letter",
//           label: "Employment Reference Letter",
//           templateUrl: null,
//           prompt: `
//         Create a reference letter from {{employerName}} for {{employeeName}}, who held the position of {{position}} for {{duration}}. Performance: {{performance}}.
//           `,
//         },
//         {
//           key: "proof_of_employment_letter",
//           label: "Proof of Employment Letter",
//           templateUrl: null,
//           prompt: `
//         Generate a proof of employment letter for {{employeeName}}, employed at {{company}} as a {{position}} since {{startDate}}, earning R{{salary}} per month.
//           `,
//         },
//         { key: "termination", label: "Termination Letter", templateUrl: null },
//         { key: "leave", label: "Leave Approval Letter", templateUrl: null },
//         { key: "warning", label: "Warning Letter", templateUrl: null },
//         { key: "consent", label: "Medical Consent Form", templateUrl: null },
//         {
//           key: "referral",
//           label: "Medical Referral Letter",
//           templateUrl: null,
//           prompt: null,
//         },
//         {
//           key: "medical_fitness_certificate",
//           label: "Medical Fitness Certificate",
//           templateUrl: null,
//           prompt: `
//         Issue a medical certificate by Dr. {{doctor}} for {{patient}}, confirming fitness for {{fitFor}}. Diagnosis: {{diagnosis}}. Date: {{date}}.
//           `,
//         },
//         {
//           key: "proof",
//           label: "Proof of Consultation Letter",
//           templateUrl: null,
//           prompt: null,
//         },
//         { key: "demand", label: "Letter of Demand", templateUrl: null },
//         { key: "affidavit", label: "Affidavit Template", templateUrl: null },
//         {
//           key: "bill_of_costs",
//           label: "Attorney Bill of Costs",
//           templateUrl: null,
//           prompt: null,
//         },
//         {
//           key: "cv_and_cover_letter_on_same_pdf_separated_by_page_break",
//           label: "CV + Cover Letter",
//           templateUrl: null,
//         },
//         { key: "loan", label: "Personal Loan Agreement", templateUrl: null },
//         {
//           key: "power_of_attorney",
//           label: "Power of Attorney",
//           templateUrl: null,
//           prompt: `
// Create a South African Power of Attorney where {{principalName}} (ID: {{idNumber}}) appoints {{appointeeName}} for {{authorityPurpose}}. Effective from {{effectiveDate}}. Format as a legal declaration.
//   `,
//         },
//         {
//           key: "lesson_plan",
//           label: "SA Educator’s Lesson Plan",
//           templateUrl: null,
//           prompt: null,
//         },
//         {
//           key: "school_transfer_letter",
//           label: "School Transfer Letter",
//           templateUrl: null,
//           prompt: `
// Write a formal school transfer letter by {{parentName}} for {{learnerName}}, moving from {{currentSchool}} to {{newSchool}}. Reason: {{transferReason}}. Addressed to the principal.
//   `,
//         },
//         {
//           key: "educational_tutor_agreement",
//           label: "Educational Tutor Agreement",
//           templateUrl: null,
//           prompt: `
//         Create a tutor agreement between {{tutor}} and {{student}} for {{subject}}. Sessions: {{frequency}}. Hourly rate: R{{rate}}.
//           `,
//         },
//         {
//           key: "internship_confirmation_letter",
//           label: "Internship Confirmation Letter",
//           templateUrl: null,
//           prompt: `
//         Confirm {{intern}} has an internship at {{company}}, Department: {{department}}, from {{startDate}} to {{endDate}} as a {{role}}.
//           `,
//         },
//         {
//           key: "sworn_affidavit_for_SASSA",
//           label: "Sworn Affidavit for SASSA",
//           templateUrl: null,
//           prompt: `
//         Generate a SASSA-compatible affidavit for {{applicantName}} (ID: {{idNumber}}), applying for a {{grantType}}. Reason: {{reason}}.
//           `,
//         },
//         {
//           key: "notice_of_disciplinary_hearing",
//           label: "Notice of Disciplinary Hearing",
//           templateUrl: null,
//           prompt: `
//         Draft a formal notice of disciplinary hearing to {{employee}} from {{employer}}. Allegation: {{allegation}}. Hearing Date: {{hearingDate}}, Location: {{location}}.
//           `,
//         },
//         {
//           key: "cohabitation_agreement",
//           label: "Cohabitation Agreement",
//           templateUrl: null,
//           prompt: `
//         Generate a cohabitation agreement between {{partner1}} and {{partner2}} living at {{address}}. Financial terms: {{financialTerms}}. Effective: {{date}}.
//           `,
//         },
//       ];
//     },
//     getDocFields() {
//       const fields = {
//         // {
//         //   title: "Proof of Residence",
//         //   fields: [
//         //     { label: "Full Name", key: "fullName" },
//         //     { label: "ID Number", key: "idNumber" },
//         //     { label: "Residential Address", key: "residence" },
//         //     { label: "Issuing Authority", key: "issuer" },
//         //     { label: "Date of Issue", key: "issueDate" }
//         //   ],
//         //   prompt: `
//         // Generate a proof of residence for {{fullName}} (ID: {{idNumber}}), living at {{residence}}. Issued by {{issuer}} on {{issueDate}}.
//         //   `
//         // }

//         // {
//         //   title: "Child Maintenance Agreement",
//         //   fields: [
//         //     { label: "Mother's Name", key: "mother" },
//         //     { label: "Father's Name", key: "father" },
//         //     { label: "Child's Name", key: "child" },
//         //     { label: "Monthly Maintenance Amount", key: "amount" },
//         //     { label: "Payment Start Date", key: "startDate" }
//         //   ],
//         //   prompt: `
//         // Write a child maintenance agreement between {{mother}} and {{father}} for their child {{child}}. Amount: R{{amount}}/month from {{startDate}}.
//         //   `
//         // }

//         // {
//         //   title: "Workplace Incident Report",
//         //   fields: [
//         //     { label: "Employee Name", key: "employeeName" },
//         //     { label: "Incident Date", key: "incidentDate" },
//         //     { label: "Incident Description", key: "incidentDescription" },
//         //     { label: "Location", key: "location" },
//         //     { label: "Witnesses", key: "witnesses" }
//         //   ],
//         //   prompt: `
//         // Generate a formal workplace incident report for {{employeeName}}. Date: {{incidentDate}}, at {{location}}. Description: {{incidentDescription}}. Witnesses: {{witnesses}}.
//         //   `
//         // }

//         // {
//         //   title: "Security Company Quotation",
//         //   fields: [
//         //     { label: "Client Name", key: "client" },
//         //     { label: "Company Name", key: "company" },
//         //     { label: "Services Offered", key: "services" },
//         //     { label: "Duration", key: "duration" },
//         //     { label: "Total Cost", key: "total" }
//         //   ],
//         //   prompt: `
//         // Create a professional quotation from {{company}} for {{client}}. Services: {{services}} for {{duration}}. Total cost: R{{total}}.
//         //   `
//         // }

//         // {
//         //   title: "Church Invitation Letter",
//         //   fields: [
//         //     { label: "Church Name", key: "church" },
//         //     { label: "Event Name", key: "event" },
//         //     { label: "Date of Event", key: "eventDate" },
//         //     { label: "Recipient Name", key: "recipient" },
//         //     { label: "Location", key: "location" }
//         //   ],
//         //   prompt: `
//         // Compose a formal invitation letter from {{church}} to {{recipient}} for {{event}} on {{eventDate}} at {{location}}.
//         //   `
//         // }

//         // {
//         //   title: "Tenant Reference Letter",
//         //   fields: [
//         //     { label: "Landlord Name", key: "landlord" },
//         //     { label: "Tenant Name", key: "tenant" },
//         //     { label: "Rental Property", key: "property" },
//         //     { label: "Rental Period", key: "rentalPeriod" },
//         //     { label: "Tenant Behavior", key: "behavior" }
//         //   ],
//         //   prompt: `
//         // Generate a reference letter by {{landlord}} for tenant {{tenant}} regarding the property at {{property}}, rented from {{rentalPeriod}}. Notes on behavior: {{behavior}}.
//         //   `
//         // }

//         // {
//         //   title: "Community Service Confirmation",
//         //   fields: [
//         //     { label: "Volunteer Name", key: "volunteer" },
//         //     { label: "Organization Name", key: "org" },
//         //     { label: "Role", key: "role" },
//         //     { label: "Service Duration", key: "duration" },
//         //     { label: "Supervisor Name", key: "supervisor" }
//         //   ],
//         //   prompt: `
//         // Confirm that {{volunteer}} completed community service at {{org}} as a {{role}} for {{duration}}. Confirmed by {{supervisor}}.
//         //   `
//         // }

//         // {
//         //   title: "Proof of Address Affidavit",
//         //   fields: [
//         //     { label: "Full Name", key: "name" },
//         //     { label: "ID Number", key: "idNumber" },
//         //     { label: "Address", key: "address" },
//         //     { label: "Date", key: "date" }
//         //   ],
//         //   prompt: `
//         // Create a South African affidavit by {{name}} (ID: {{idNumber}}) confirming residential address: {{address}}. Dated: {{date}}.
//         //   `
//         // }

//         // {
//         //   title: "Home Affairs Invitation Letter",
//         //   fields: [
//         //     { label: "Inviter's Full Name", key: "inviter" },
//         //     { label: "Invitee's Full Name", key: "invitee" },
//         //     { label: "Visit Reason", key: "reason" },
//         //     { label: "Visit Dates", key: "dates" },
//         //     { label: "Address of Stay", key: "stayAddress" }
//         //   ],
//         //   prompt: `
//         // Generate a South African Home Affairs invitation letter from {{inviter}} to {{invitee}}, for {{reason}}, staying at {{stayAddress}} from {{dates}}.
//         //   `
//         // }

//         //Old fields
//         sworn_affidavit_for_SASSA: [
//           { label: "Applicant Name", key: "applicantName" },
//           { label: "ID Number", key: "idNumber" },
//           { label: "Reason for Affidavit", key: "reason" },
//           { label: "Application Type", key: "grantType" },
//         ],
//         affidavit_for_lost_id: [
//           { label: "Full Name", key: "name" },
//           { label: "ID Number", key: "id" },
//           { label: "Circumstances of Loss", key: "details" },
//           { label: "Date of Loss", key: "lossDate" },
//         ],
//         notice_of_disciplinary_hearing: [
//           { label: "Employee Name", key: "employee" },
//           { label: "Employer Name", key: "employer" },
//           { label: "Hearing Date", key: "hearingDate" },
//           { label: "Allegation", key: "allegation" },
//           { label: "Location", key: "location" },
//         ],
//         cohabitation_agreement: [
//           { label: "Partner 1 Name", key: "partner1" },
//           { label: "Partner 2 Name", key: "partner2" },
//           { label: "Shared Address", key: "address" },
//           { label: "Financial Terms", key: "financialTerms" },
//           { label: "Effective Date", key: "date" },
//         ],
//         medical_fitness_certificate: [
//           { label: "Patient Name", key: "patient" },
//           { label: "Doctor Name", key: "doctor" },
//           { label: "Diagnosis Summary", key: "diagnosis" },
//           { label: "Fit For", key: "fitFor" },
//           { label: "Certificate Date", key: "date" },
//         ],
//         lease_cancellation_letter: [
//           { label: "Tenant Name", key: "tenantName" },
//           { label: "Landlord Name", key: "landlordName" },
//           { label: "Property Address", key: "address" },
//           { label: "Effective Cancellation Date", key: "cancelDate" },
//           { label: "Reason", key: "reason" },
//         ],
//         proof_of_employment_letter: [
//           { label: "Employee Name", key: "employeeName" },
//           { label: "Position", key: "position" },
//           { label: "Employment Start Date", key: "startDate" },
//           { label: "Company Name", key: "company" },
//           { label: "Monthly Salary", key: "salary" },
//         ],
//         internship_confirmation_letter: [
//           { label: "Company Name", key: "company" },
//           { label: "Intern Name", key: "intern" },
//           { label: "Department", key: "department" },
//           { label: "Start Date", key: "startDate" },
//           { label: "End Date", key: "endDate" },
//           { label: "Intern Role", key: "role" },
//         ],
//         employment_reference_letter: [
//           { label: "Employer Name", key: "employerName" },
//           { label: "Employee Name", key: "employeeName" },
//           { label: "Position Held", key: "position" },
//           { label: "Employment Duration", key: "duration" },
//           { label: "Performance Summary", key: "performance" },
//         ],
//         business_plan: [
//           { label: "Business Name", key: "businessName" },
//           { label: "Owner Name", key: "ownerName" },
//           { label: "Business Sector", key: "sector" },
//           { label: "Business Goals", key: "goals" },
//           { label: "Products/Services", key: "products" },
//           { label: "Target Market", key: "market" },
//           { label: "Financial Summary", key: "financeSummary" },
//         ],
//         letter_of_good_standing: [
//           { label: "Company Name", key: "company" },
//           { label: "Requestor Name", key: "name" },
//           { label: "ID or Reg Number", key: "idNumber" },
//           { label: "Reason", key: "reason" },
//         ],
//         travel_consent_for_minor: [
//           { label: "Parent Name", key: "parent" },
//           { label: "Child Name", key: "child" },
//           { label: "Destination", key: "destination" },
//           { label: "Travel Dates", key: "dates" },
//           { label: "Accompanying Person", key: "accompanying" },
//         ],
//         stokvel_membership_agreement: [
//           { label: "Member Name", key: "member" },
//           { label: "Stokvel Name", key: "stokvel" },
//           { label: "Contribution Amount", key: "amount" },
//           { label: "Contribution Frequency", key: "frequency" },
//           { label: "Agreement Date", key: "date" },
//         ],
//         acknowledgement_of_debt: [
//           { label: "Debtor Name", key: "debtor" },
//           { label: "Creditor Name", key: "creditor" },
//           { label: "Amount Owed", key: "amount" },
//           { label: "Payment Terms", key: "terms" },
//           { label: "Agreement Date", key: "date" },
//         ],
//         educational_tutor_agreement: [
//           { label: "Tutor Name", key: "tutor" },
//           { label: "Student Name", key: "student" },
//           { label: "Subject", key: "subject" },
//           { label: "Session Frequency", key: "frequency" },
//           { label: "Hourly Rate", key: "rate" },
//         ],
//         vehicle_sale_agreement: [
//           { label: "Seller Name", key: "sellerName" },
//           { label: "Buyer Name", key: "buyerName" },
//           { label: "Vehicle Details", key: "vehicleDetails" },
//           { label: "Registration Number", key: "registrationNumber" },
//           { label: "Sale Price", key: "salePrice" },
//           { label: "Date of Sale", key: "saleDate" },
//         ],
//         freelance_contract: [
//           { key: "client", label: "Client Name" },
//           { key: "projectDescription", label: "Project Description" },
//           { label: "Freelancer Name", key: "freelancer" },
//           { label: "Service Description", key: "services" },
//           { label: "Project Amount", key: "fee" },
//           { label: "Completion Deadline", key: "deadline" },
//         ],
//         invoice: [
//           { key: "clientName", label: "Client Name" },
//           { key: "services", label: "Services Rendered" },
//           { key: "total", label: "Total Amount" },
//           { key: "dueDate", label: "Due Date" },
//         ],
//         late_payment: [
//           { key: "clientName", label: "Client Name" },
//           { key: "invoiceNumber", label: "Invoice Number" },
//           { key: "amountDue", label: "Amount Due" },
//           { key: "dueDate", label: "Original Due Date" },
//         ],
//         debt_collection: [
//           { key: "debtorName", label: "Debtor Name" },
//           { key: "amount", label: "Amount Owed" },
//           { key: "serviceDescription", label: "Service/Product Description" },
//         ],
//         nda: [
//           { label: "Disclosing Party", key: "discloser" },
//           { label: "Receiving Party", key: "receiver" },
//           { key: "scope", label: "Confidentiality Scope" },
//           { label: "Purpose of NDA", key: "purpose" },
//           { label: "Effective Date", key: "effectiveDate" },
//           { label: "Duration (in months)", key: "duration" },
//         ],
//         contract: [
//           { key: "partyA", label: "Party A Name" },
//           { key: "partyB", label: "Party B Name" },
//           { key: "agreementDetails", label: "Agreement Details" },
//         ],
//         partnership: [
//           { key: "partnerOne", label: "Partner One" },
//           { key: "partnerTwo", label: "Partner Two" },
//           { key: "businessDetails", label: "Business Purpose" },
//         ],
//         lease: [
//           { key: "tenant", label: "Tenant Name" },
//           { key: "landlord", label: "Landlord Name" },
//           { key: "propertyAddress", label: "Property Address" },
//           { key: "leaseAmount", label: "Monthly Rent" },
//         ],
//         resignation: [
//           { key: "employeeName", label: "Employee Name" },
//           { key: "employerName", label: "Employer Name" },
//           { key: "lastDay", label: "Last Working Day" },
//         ],
//         employment: [
//           { key: "employeeName", label: "Employee Name" },
//           { key: "jobTitle", label: "Job Title" },
//           { key: "salary", label: "Salary" },
//         ],
//         termination: [
//           { key: "employeeName", label: "Employee Name" },
//           { key: "terminationDate", label: "Termination Date" },
//           { key: "reason", label: "Reason for Termination" },
//         ],
//         leave: [
//           { key: "employeeName", label: "Employee Name" },
//           { key: "leaveType", label: "Type of Leave" },
//           { key: "dates", label: "Leave Dates" },
//         ],
//         warning: [
//           { key: "employeeName", label: "Employee Name" },
//           { key: "issue", label: "Issue Description" },
//           { key: "warningDate", label: "Date of Warning" },
//         ],
//         consent: [
//           { key: "patientName", label: "Patient Name" },
//           { key: "guardianName", label: "Guardian (if any)" },
//           { key: "procedure", label: "Procedure Description" },
//         ],
//         referral: [
//           { key: "patientName", label: "Patient Name" },
//           { key: "doctorName", label: "Referring Doctor" },
//           { key: "reason", label: "Reason for Referral" },
//         ],
//         proof: [
//           { key: "patientName", label: "Patient Name" },
//           { key: "visitDate", label: "Consultation Date" },
//           { key: "doctorName", label: "Doctor’s Name" },
//         ],
//         demand: [
//           { key: "debtorName", label: "Debtor Name" },
//           { key: "amount", label: "Amount Owed" },
//           { key: "deadline", label: "Deadline Date" },
//         ],
//         affidavit: [
//           { key: "fullName", label: "Your Full Name" },
//           { key: "statement", label: "Affidavit Statement" },
//         ],
//         bill_of_costs: [
//           { key: "clientName", label: "Client Name" },
//           { key: "caseNumber", label: "Case Number" },
//           { key: "charges", label: "Breakdown of Charges" },
//         ],
//         cv_and_cover_letter_on_same_pdf_separated_by_page_break: [
//           { key: "fullName", label: "Full Name" },
//           { key: "highestQualification", label: "Highest Qualification" },
//           { key: "industry", label: "Industry Interested In" },
//           { key: "experience", label: "Experience Summary" },
//           { key: "skills", label: "Key Skills" },
//         ],
//         loan: [
//           { key: "borrowerName", label: "Borrower Name" },
//           { key: "lenderName", label: "Lender Name" },
//           { key: "amount", label: "Loan Amount" },
//           { key: "repaymentTerms", label: "Repayment Terms" },
//         ],
//         power_of_attorney: [
//           { key: "grantor", label: "Grantor Name" },
//           { key: "agent", label: "Agent Name" },
//           { key: "scope", label: "Authority Scope" },
//           { label: "Principal Name", key: "principalName" },
//           { label: "ID Number", key: "idNumber" },
//           { label: "Appointee Name", key: "appointeeName" },
//           { label: "Purpose of Authority", key: "authorityPurpose" },
//           { label: "Effective Date", key: "effectiveDate" },
//         ],
//         lesson_plan: [
//           { key: "subject", label: "Subject" },
//           { key: "grade", label: "Grade" },
//           { key: "theme", label: "Theme/Topic" },
//           { key: "outcomes", label: "Learning Outcomes" },
//           { key: "assessment", label: "Assessment Methods" },
//           { key: "date", label: "Date of Lesson" },
//         ],
//         school_transfer_letter: [
//           { label: "Parent Full Name", key: "parentName" },
//           { label: "Learner Full Name", key: "learnerName" },
//           { label: "Current School", key: "currentSchool" },
//           { label: "New School", key: "newSchool" },
//           { label: "Reason for Transfer", key: "transferReason" },
//         ],
//       };
//       return fields;
//       //return fields[this.selectedDocType] || [];
//     },
//     isFormValid() {
//       return Object.values(this.docData).every((v) => !!v);
//     },
//   },
//   data() {
//     return {
//       countryContext: localStorage.getItem("countryContext") || null,
//       getCurrency: localStorage.getItem("getCurrency") || null,
//       timezone: localStorage.getItem("timezone") || null,
//       regionName: localStorage.getItem("regionName") || null,
//       docsAiLogObj: JSON.parse(localStorage.getItem("getCurrency")) || null,
//       currentStep: 1,
//       selectedDocTemplateUrl: null,
//       selectedDocTemplatePrompt: null,
//       selectedDocType: null,
//       extraSpecificRequirement: "",
//       selectedTier: "single",
//       docData: {},
//       pdfContent: "",
//       pdfBlobUrl: "",
//       paymentDone: false,
//       chatGPTKey:
//         "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",
//       showPaymentModal: false,
//       loading: false,
//       loadingPaypal: false,
//       loadingPayfast: false,
//       formValid: false,
//       brand: {
//         name: "",
//         logoUrl: "",
//         logoFile: null,
//         logoBase64: "",
//         address: "",
//         phone: "",
//       },
//     };
//   },
//   async mounted() {
//     this.$store.commit("setLoader", true);
//     //await this.registerIPAndGetCountryContext();
//     this.$store.commit("setLoader", false);
//   },
//   methods: {
//     async registerIPAndGetCountryContext() {
//       const data = await axios.postData("/get-docs-ai-data", {});
//       console.log(data);
//       if (data && data.ipData && !this.countryContext) {
//         this.countryContext = data.ipData.countryName;
//         this.getCurrency = data.ipData.currencyCode;
//         this.timezone = data.ipData.timezone;
//         this.regionName = data.ipData.regionName;
//         this.docsAiLogObj = data.log;

//         localStorage.setItem("countryContext", data.ipData.countryName);
//         localStorage.setItem("getCurrency", data.ipData.currencyCode);
//         localStorage.setItem("timezone", data.ipData.timezone);
//         localStorage.setItem("regionName", data.ipData.regionName);
//         localStorage.setItem("docsAiLogObj", JSON.stringify(data.log));
//       }
//     },
//     async capturePaymentOnAiLog() {
//       const data = await axios.postData("/capture-payment-docs-ai", {
//         amount: 0,
//       });
//       console.log(data);
//     },
//     getSelectedDocTemplateUrl() {
//       const docObj = this.documentTypes.find((docType) => {
//         return docType.key == this.selectedDocType;
//       });
//       if (docObj) {
//         if (docObj && docObj.templateUrl) {
//           this.selectedDocTemplateUrl = docObj.templateUrl;
//         } else {
//           this.selectedDocTemplateUrl = null;
//         }

//         if (docObj && docObj.prompt) {
//           this.selectedDocTemplatePrompt = docObj.prompt;
//         } else {
//           this.selectedDocTemplatePrompt = null;
//         }
//         if (this.currentStep == 1) {
//           this.currentStep = 2;
//         }
//       }
//     },
//     handleLogoUpload(file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         this.brand.logoBase64 = e.target.result;
//       };
//       if (file) {
//         reader.readAsDataURL(file);
//       }
//     },

//     async generateDocument() {
//       if (!this.$refs.form.validate()) return;

//       if (this.isLimitExceeded) {
//         this.$toast.warning(
//           "You’ve reached your document limit. Upgrade or wait until next cycle."
//         );
//         this.$emit(
//           "showSnackbar",
//           "You’ve reached your document limit. Upgrade or wait until next cycle."
//         );
//         return;
//       }

//       this.$store.commit("setLoader", true);
//       this.loading = true;
//       const prompt = this.buildPrompt(this.selectedDocType, this.docData);

//       try {
//         const result = await this.generateWithChatGPT(prompt);
//         this.pdfContent = JSON.parse(result);

//         this.generatePDF();
//         if (this.isGuestOrLimited && !this.paymentDone) {
//           this.showPaymentModal = true;
//         }

//         // Simulate incrementing usage
//         //await this.registerIPAndGetCountryContext();
//         //this.getCurrentUser.generatedDocsThisMonth += 1;
//         //this.getCurrentUser.generatedDocsThisYear += 1;
//       } catch (e) {
//         console.error(e);
//       } finally {
//         this.loading = false;
//         this.$store.commit("setLoader", false);
//       }
//     },
//     payWithPayFast() {
//       this.loadingPayfast = true;
//       setTimeout(() => {
//         window.open("https://www.payfast.io/eng/process", "_blank"); // Simulated redirect
//         this.paymentDone = true;
//         this.showPaymentModal = false;
//         this.loadingPayfast = false;
//         this.generatePDF();
//       }, 1000);
//     },

//     payWithPayPal() {
//       this.loadingPaypal = true;
//       setTimeout(() => {
//         window.open(
//           "https://www.paypal.com/checkoutnow?token=YOUR_TOKEN_HERE",
//           "_blank"
//         ); // Simulated
//         this.paymentDone = true;
//         this.showPaymentModal = false;
//         this.loadingPaypal = false;
//         this.generatePDF();
//       }, 1000);
//     },
//     generatePDF() {
//       const docDefinition = this.pdfContent;

//       docDefinition.content.unshift({
//         canvas: [{ type: "line", x1: 0, y1: 0, x2: 500, y2: 0, lineWidth: 1 }],
//       });
//       docDefinition.content.unshift({ text: "\n" });
//       docDefinition.content.unshift({
//         columns: [
//           this.brand.logoBase64 || this.brand.logoUrl
//             ? {
//                 image: this.brand.logoBase64 || this.brand.logoUrl,
//                 width: 100,
//               }
//             : "",
//           [
//             { text: this.brand.name, style: "MyHeader" },
//             { text: this.brand.address, style: "MySubheader" },
//             { text: this.brand.phone, style: "MySubheader" },
//           ],
//         ],
//         margin: [0, 0, 0, 10],
//       });

//       docDefinition.watermark = {
//         text: "Docs-Ai.co.za Payment Required!",
//         color: "red",
//         opacity: 0.3,
//         bold: true,
//         italics: false,
//       };

//       if (!docDefinition.styles) {
//         docDefinition.styles = {
//           MyHeader: {
//             fontSize: 16,
//             bold: true,
//             color: this.getThemeColor,
//           },
//           MySubheader: {
//             fontSize: 13,
//             color: this.getThemeColor,
//           },
//         };
//       } else {
//         docDefinition.styles.Myheader = {
//           fontSize: 16,
//           bold: true,
//           color: this.getThemeColor,
//         };

//         docDefinition.styles.MySubheader = {
//           fontSize: 13,
//           color: this.getThemeColor,
//         };
//       }

//       // this.pdfContent Insert AI-generated content here
//       const pdfDoc = pdfMake.createPdf(docDefinition);
//       pdfDoc.getBlob((blob) => {
//         this.pdfBlobUrl = URL.createObjectURL(blob);
//       });
//     },

//     buildPrompt(type, data) {
//       let intro = `You are a legal, business, medical, educational, tender or insurance documents expert in ${
//         this.countryContext
//       }. Generate a structured, well formatted, professional "${type.replace(
//         /_/g,
//         " "
//       )}" based on:\n`;
//       for (const key in data) {
//         intro += `- ${key}: ${data[key]}\n`;
//       }

//       if (this.selectedDocTemplatePrompt) {
//         intro += this.selectedDocTemplatePrompt;
//       }

//       if (this.getCurrency) {
//         intro += `if currency is needed in the creation of this document, use ${this.getCurrency} for it. example, for fees, for prices, for amounts etc. all monies should use ${this.getCurrency}`;
//         intro += `use ${this.timezone} as the time zone for all time related aspect of the document generation`;
//         intro += `use ${this.regionName} as the specific local region or province for specificity in the appropriate document template to be used in the document generation`;
//       }

//       if (this.extraSpecificRequirement) {
//         intro += this.extraSpecificRequirement;
//       }
//       intro += `\nRespond ONLY with formatted text suitable for pdfMake, including sections, bullet points, and clear headings. Do not include markdown or code.`;
//       //intro += `\nRespond ONLY with formatted text suitable for pdfMake. No markdown or code.`;
//       intro += `\n As an expert in generating professional documents, check and make sure that all spellings are correct, and that the format used in the document is the current accepted format in the above named country.`;
//       if (this.selectedDocTemplateUrl) {
//         intro += `analyse carefully the given template at this location ${this.selectedDocTemplateUrl}, and strictly structure the format of the document to match it. you can allowed to recreate it using pdfmake but the format and the position of text and images must match the template.`;
//       }
//       return intro;
//     },

//     async generateWithChatGPT(prompt) {
//       const response = await fetch(
//         "https://api.openai.com/v1/chat/completions",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${this.chatGPTKey}`,
//           },
//           body: JSON.stringify({
//             model: "gpt-4",
//             messages: [{ role: "user", content: prompt }],
//             temperature: 0.4,
//           }),
//         }
//       );

//       const json = await response.json();
//       return json.choices[0]?.message?.content || "Failed to generate document";
//     },
//     downloadPDF() {
//       pdfMake
//         .createPdf(this.pdfContent)
//         .download(`${this.selectedDocType}.pdf`);
//       // pdfMake
//       //   .createPdf({ content: [{ text: this.pdfContent }] })
//       //   .download(`${this.selectedDocType}.pdf`);
//     },
//   },
// };
</script>
